export const DELETE_SALON_TAG_REQUEST = 'DELETE_SALON_TAG_REQUEST';
export const DELETE_SALON_TAG_SUCCESS = 'DELETE_SALON_TAG_SUCCESS';
export const DELETE_SALON_TAG_FAILURE = 'DELETE_SALON_TAG_FAILURE';
